import Api from '../api';

const bookingsEndpoint = '/bookings';
const deliveriesEndpoint = `${bookingsEndpoint}/deliveries`;

const TypedBookingsAPI = {
  async checkInDelivery(deliveryId: string, deliveredAt: Date) {
    return Api.put(`${deliveriesEndpoint}/${deliveryId}/checkin`, {
      data: { delivered_at: deliveredAt },
    });
  },
};

export default TypedBookingsAPI;
